export default `float de(vec3 p){
    vec3 Q;
    float i,d=1.;
    Q=abs(fract(p)-.5),
    Q=Q.x>Q.z?Q.zyx:Q,
    d=9.,    D,
    Q-=.5,   D,
    Q.x+=.5,
    Q=Q.xzy, D,
    Q.z+=.5,
    Q=Q.zxy, D;
    return d;
  }`